import React from 'react';
import PropTypes from 'prop-types';

import FieldLabel from '../FieldLabel';
import TextAreaInput from '../TextAreaInput';
import styles from './styles.scss';
import withValidation from '../../shared/withValidation';

class LabeledTextAreaInput extends React.PureComponent {
  render() {
    const { editMode, label, value, isnLabel, error } = this.props;

    return (
      <div>
        <FieldLabel isnLabel={isnLabel}>{label}</FieldLabel>
        <Choose>
          <When condition={editMode}>
            <TextAreaInput {...this.props} />
          </When>
          <Otherwise>
            <label className={`d-block ${styles.label}`}>{value || '-'}</label>
            {error && <label className={styles.error}>{error}</label>}
          </Otherwise>
        </Choose>
      </div>
    );
  }
}

LabeledTextAreaInput.propTypes = {
  editMode: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  value: PropTypes.string,
  type: PropTypes.string,
  isnLabel: PropTypes.bool,
  placeholder: PropTypes.string,
  allowBlank: PropTypes.bool,
  error: PropTypes.string,
};

export default withValidation(LabeledTextAreaInput);



// WEBPACK FOOTER //
// src/components/shared/LabeledTextAreaInput/index.jsx